import { render } from "./RestaurantMenuView.vue?vue&type=template&id=28e10870&scoped=true"
import script from "./RestaurantMenuView.vue?vue&type=script&lang=js"
export * from "./RestaurantMenuView.vue?vue&type=script&lang=js"

import "./RestaurantMenuView.vue?vue&type=style&index=0&id=28e10870&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e10870"]])

export default __exports__